import React from 'react';
import { GlobalStyles } from '@mui/material';

const CustomGlobalStyles = () => (
    <GlobalStyles
        styles={{
            '::-ms-reveal': {
                display: 'none',
            },
        }}
    />
);

export default CustomGlobalStyles;
